import { openBlock as r, createElementBlock as t, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(a, l) {
  return r(), t("svg", o, [...l[0] || (l[0] = [
    e("g", { "clip-path": "url(#a)" }, [
      e("path", {
        fill: "currentColor",
        d: "M19 11H7.83l4.88-4.88c.39-.39.39-1.03 0-1.42a.996.996 0 0 0-1.41 0l-6.59 6.59a.996.996 0 0 0 0 1.41l6.59 6.59a.996.996 0 1 0 1.41-1.41L7.83 13H19c.55 0 1-.45 1-1s-.45-1-1-1"
      })
    ], -1),
    e("defs", null, [
      e("clipPath", { id: "a" }, [
        e("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])]);
}
const i = { render: n };
export {
  i as default,
  n as render
};
